/**
 * Copyright IBM Corp. 2016, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import wrapComponent from '../../tools/wrapComponent.js';

var TableToolbarContent = wrapComponent({
  name: 'TableToolbarContent',
  type: 'div',
  className: function className(prefix) {
    return "".concat(prefix, "--toolbar-content");
  }
});
var TableToolbarContent$1 = TableToolbarContent;

export { TableToolbarContent$1 as default };
